var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportingCard',{attrs:{"title":_vm.title}},[_c('RChartDonut',{attrs:{"data":_vm.data,"options":_vm.options,"sort-method":_vm.sortMethod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }